import { useContext } from 'react';
import { FlowyGlobal } from '../../flowy';
import { FlowyGlobalContext } from '../providers/flowy-global-context';

/**
 * Custom hook used to get the FlowyGlobalContext, which basically is the instance
 * of FlowyGlobal
 */
const useFlowyGlobalContext = (): FlowyGlobal | undefined => {
  return useContext(FlowyGlobalContext);
};

export default useFlowyGlobalContext;
